import { CREATE } from 'react-admin';

const dataCharge = (instance, type, params) => {
  const opt = {};
  switch (type) {
    case CREATE: {
      const { amount, entityId, productId, serviceId } = params.data;
      opt.url = `/business/fleets/${localStorage.getItem('fleetID')}/business/${entityId}/product`;
      opt.method = 'POST';
      opt.data = { amount, productId, serviceId };
      break;
    }
    default:
      throw new Error(`Unsupported Data Provider request type ${type}`);
  }
  return instance(opt);
};

export default dataCharge;
